import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef({
  params: ['namespace', 'kind', 'name'],
});
